import { FILES } from './files';

// Page copy that is not circulars. Everything here is from the design; items
// the client has not approved are flagged by DraftMarkers on the pages.

export const AIMS: { text: string; link?: { label: string; to: string } }[] = [
  { text: 'Affiliate institutes that teach technical and vocational courses.', link: { label: 'Affiliation', to: '/affiliation' } },
  { text: 'Establish regional branches.' },
  { text: 'Conduct examinations and award certificates and diplomas.', link: { label: 'Examinations', to: '/examinations' } },
  { text: 'Work with professional organisations in technical education.' },
  { text: 'Maintain a library and research laboratory.' },
  { text: 'Publish bulletins and educational material.', link: { label: "Student's E-Journal", to: '/e-journal' } },
  { text: 'Carry out activities incidental to these aims.' },
];

export const FOUNDERS = [
  'Dr K. S. Mhaskar', 'Dr V. K. Dongre', 'Dr S. H. Marathe', 'Mr D. H. Marathe', 'Dr R. V. Sathe',
  'Dr V. V. Ukidve', 'Dr V. J. Gharpure', 'Mr Dh. H. Marathe', 'J. R. Gharpure',
];


export const EXAM_DOCS: { title: string; meta: string; file?: string }[] = [
  { title: 'Student examination application form', meta: 'Form · PDF', file: FILES.examApplicationForm },
  { title: 'Seat numbers', meta: 'Session · PDF', file: FILES.seatNumbers },
  { title: 'Student merit list', meta: 'Session · PDF', file: FILES.meritList },
  { title: 'Revised course fee / new courses', meta: 'PDF', file: FILES.revisedCourseFee },
];

export const EXAM_STEPS = [
  'Your affiliated institute sponsors you for the ITES examination.',
  'You sit theory and practical papers at an approved exam centre.',
  'ITES issues results, merit lists and certificates.',
];

export const AFFILIATION_RULES = [
  'Affiliation procedure',
  'Documents required',
  'Inspection and re-affiliation conditions',
  'Privileges and obligations of institutes',
  'Jurisdiction (Mumbai)',
];

export const OVERSEAS_RULES = [
  'Affiliation and examination rules',
  'Responsibilities of overseas centres',
  'Inspection conditions',
  'Currency and payment terms',
];

export const GOA_GALLERY_COUNT = 8;
